import ExternalTemplate from './ExternalTemplate';
export default ExternalTemplate;